import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Client } from 'src/app/models/client.model';
import { ClientLimitQuery } from 'src/app/models/limits.model';
import { ErpService } from 'src/app/services/net/erp.service';
import { ConnectionManagerService } from 'src/app/services/storage/connection-manager.service';
import { LimitCreateComponent } from '../limit-create/limit-create.component';

@Component({
  selector: 'app-limit-list',
  templateUrl: './limit-list.component.html',
  styleUrl: './limit-list.component.scss'
})
export class LimitListComponent {
  limits: ClientLimitQuery[] = [];
  viewLimits: ClientLimitQuery[] = [];
  loading = false;

  agents: any [] = []
  statuses: any[] = []
  choosenManager: string | undefined
  choosenStatus: string | undefined
  choosenDate: string | undefined
  dates: any[] = []

  @Input()
  public buypoint: Client | undefined

  constructor(private erp: ErpService,
    public connMgr: ConnectionManagerService,
    public route: ActivatedRoute,
    private snack: MatSnackBar,
    private router: Router


  ) {


  }

  ngOnInit(): void {

    const q = this.connMgr.activeServerObservable().subscribe((srv) => {
      this.search()
    })


  }


  search() {

    this.loading = false;
    this.limits = [];



    this.erp.getLimitQueries(this.buypoint?.code).subscribe(
      {
        next: (limits) => {
          this.limits = limits.Result;
          this.viewLimits = limits.Result
          this.loading = false;
          this.choosenManager = undefined

          this.agents = this.limits
            .filter(element => element.AgentName !== undefined)
            .map(element => element.AgentName === "" ? "«Все агенты»" : element.AgentName)
            .filter((value, index, self) => self.indexOf(value) === index);
          this.agents.sort()

          this.statuses = this.limits
            .filter(element => element.Status !== undefined)
            .map(element => element.Status)
            .filter((value, index, self) => self.indexOf(value) === index);
          this.agents.sort()

          this.dates = this.limits
            .filter(element => element.Date !== undefined)
            .map(element => element.Date.toString().substring(0,10))
            .filter((value, index, self) => self.indexOf(value) === index);
          this.agents.sort()

          

          if (!limits.Success) {
            console.error(limits.ErrorText)
          }
        },
        error: (err) => {
          this.loading = false;
          console.error(err);
          this.snack.open('Не удалось загрузить запросы', 'ok', { duration: 5000 })

        }
      }
    )

  }


  add() {

    if (!this.buypoint){
      return
    }

    this.router.navigate(["/limit-query-create", this.buypoint.id])

  }

    applyFilter() {
    this.loading = true
    const filtered = this.limits.filter(d =>
      (this.choosenManager === undefined || this.choosenManager === d.AgentName) &&
      (this.choosenStatus === undefined || this.choosenStatus === d.Status) &&
      (this.choosenDate === undefined || this.choosenDate.startsWith(d.Date.toString().split('T')[0])))
    
    this.viewLimits = filtered
    this.loading = false
  }

}
